export enum WIDGET_SETTINGS {
    /**
     * @value Dynamic selection
     */
    AUTOMATIC_OPTION_HELPER = 'WIDGET_SETTINGS_SELECTION_DYNAMIC',
    /**
     * @value Automatic
     */
    AUTOMATIC_OPTION_LABEL = 'FRONT.SETTINGS.SELECTION_LIST',
    /**
     * @value Select the criteria the system will use to dynamically display items in this widget.
     * @description Description of the Criteria section in widgets settings, explaining how criteria drive dynamic content display.
     */
    CRITERIA_SECTION_DESCRIPTION = 'WIDGET_SETTINGS.CRITERIA_SECTION_DESCRIPTION',
    /**
     * @value Criteria
     * @description Title of the Criteria section in the widgets settings.
     */
    CRITERIA_SECTION_TITLE = 'WIDGET_SETTINGS.CRITERIA_SECTION_TITLE',
    /**
     * @value Only available for dynamic and manual selection type
     * @description The message displayed to explain why the "Followed communities only" filter is disabled on the widget event list and on the widget article list.
     */
    DISABLED_FOLLOWED_COMMUNITIES_FILTER_HELPER = 'WIDGET_EVENT_LIST.SETTINGS_DISABLED_FOLLOWED_COMMUNITIES_FILTER_HELPER',
    /**
     * @value Double click on the widget to add content.
     */
    DOUBLE_CLICK_INFO = 'WIDGET_CONTRIBUTION.SETTINGS_DOUBLE_CLICK_INFO',
    /**
     * @value Followed communities only
     * @description In the widget settings, the label of the switch filter to display only entities from the followed communities.
     */
    FOLLOWED_COMMUNITIES_ONLY = 'WIDGET_SETTINGS.FOLLOWED_COMMUNITIES_ONLY',
    /**
     * @value Fixed selection
     */
    MANUAL_OPTION_HELPER = 'WIDGET_SETTINGS.MANUAL_SELECTION_OPTION_HELPER',
    /**
     * @value Manual
     */
    MANUAL_OPTION_LABEL = 'FRONT.SETTINGS.SELECTION_PICK',
    /**
     * @value Settings have changed. Click "Preview results" to see updated items.
     * @description Helper text displayed in the widget settings dialog, below a 'refresh preview' button, when the current (unsaved) settings differ from the last previewed state — prompting the user to refresh the preview to see up-to-date results.
     */
    PREVIEW_NEED_UPDATE_HELPER = 'WIDGET_SETTINGS.PREVIEW_NEED_UPDATE_HELPER',
    /**
     * @value This widget can show up to %MAX_NB_ITEMS% items
     * @description Helper text displayed below the preview section title in the widget settings dialog, indicating the maximum number of items the widget can display. Contains a variable for the item count. %MAX_NB_ITEMS%
     */
    PREVIEW_SECTION_HELPER_TEXT = 'WIDGET_SETTINGS.PREVIEW_SECTION_HELPER_TEXT',
    /**
     * @value Click "Preview results" to see items.
     * @description In widget settings dialog, message displayed in the preview section, when no preview has been fetched yet. Inviting user to generate a preview.
     */
    PREVIEW_SECTION_INITIAL_STATE_MESSAGE = 'WIDGET_SETTINGS.PREVIEW_SECTION_INITIAL_STATE_MESSAGE',
    /**
     * @value Selection overview
     * @description Title of the preview section in the widget settings dialog, displayed above the list of items matching the current settings.
     */
    PREVIEW_SECTION_TITLE = 'WIDGET_SETTINGS.PREVIEW_SECTION_TITLE',
    /**
     * @value Restrictions
     * @description The section title for restrictions in widget settings
     */
    RESTRICTIONS_SECTION_TITLE = 'WIDGET_SETTINGS.RESTRICTIONS_SECTION_TITLE',
    /**
     * @value Sorting criteria
     * @description Label for the sorting criteria select field in widget settings.
     */
    SORTING_CRITERIA_LABEL = 'WIDGET_SETTINGS.SORTING_CRITERIA_LABEL',
    /**
     * @value Define the order in which items appear in your list.
     * @description Description of the Sorting section in the widget settings.
     */
    SORTING_DESCRIPTION = 'WIDGET_SETTINGS.SORTING_DESCRIPTION',
    /**
     * @value Preview results
     * @description The label of the button in the widget settings dialog that refreshes the preview list to reflect the current (unsaved) settings.
     */
    UPDATE_PREVIEW_BUTTON_LABEL = 'WIDGET_SETTINGS.UPDATE_PREVIEW_BUTTON_LABEL',
    /**
     * @value View mode
     */
    VIEW_MODE = 'ADMIN.CUSTOMER.STREAMS.VIEW_MODE',
    /**
     * @value Empty widget
     * @description Text display on a button as a tooltip to warn the user this action will empty the widget
     */
    WIDGET_CLEAR_ACTION_LABEL = 'CONTENT_EDITOR.WIDGET_CLEAR_ACTION_LABEL',
    /**
     * @value Widget edition menu
     * @description The label read by screenreader for the menubar holding editing options for a given widget. Will be read by screen readers with the widget title and type to give more context.
     */
    WIDGET_EDITION_MENUBAR_LABEL = 'CONTENT_EDITOR.WIDGET_EDITION_MENUBAR_LABEL',
    /**
     * @value Content may vary per user. Refer to the documentation for details.
     * @description In the widget settings dialog, gives contextual informations about the content of the widget. The content of the widget is not exactly the same for every user.
     */
    WIDGET_LIST_PREVIEW_INFORMATION_MESSAGE = 'WIDGET_SETTINGS.WIDGET_LIST_PREVIEW_INFORMATION_MESSAGE',
}
